import { createSlice } from '@reduxjs/toolkit'

const transactions = createSlice({
  name: 'transactions',
  initialState: {
    data: null,
    isLoading: false,
    isError: null,
    pagination: {
      page: 1,
      lastPage: 1,
    },
    newTransaction: {
      data: null,
      isLoading: false,
      isError: null,
    },
    balances: {
      data: null,
      isLoading: true,
      isError: null,
    },
    comission: {
      data: null,
      isLoading: true,
      isError: null,
    },
    massivePayments: {
      excel: {
        validation: {
          data: null,
          isLoading: false,
          errors: [],
        },
        payment: {
          data: null,
          isLoading: false,
          error: null,
        },
        status: {
          data: null,
          isLoading: false,
          error: null,
        },
      },
      aliases: {
        data: null,
        isLoading: false,
        errors: [],
      },
    },
    bridge: {
      comission: {
        data: null,
        isLoading: false,
        error: null,
      },
      transaction: {
        data: null,
        isLoading: false,
        error: null,
      },
    },
  },
  reducers: {
    setTransactions: (state, action) => {
      state.data = action.payload.data
      state.isLoading = action.payload.isLoading
      state.isError = action.payload.isError
      state.pagination = action.payload.pagination
    },
    setNewTransaction: (state, action) => {
      state.newTransaction.data = action.payload.data
      state.newTransaction.isLoading = action.payload.isLoading
      state.newTransaction.isError = action.payload.isError
    },
    setBalances: (state, action) => {
      state.balances.data = action.payload.data
      state.balances.isLoading = action.payload.isLoading
      state.balances.isError = action.payload.isError
    },
    setComission: (state, action) => {
      state.comission.data = action.payload.data
      state.comission.isLoading = action.payload.isLoading
      state.comission.isError = action.payload.isError
    },
    setMassivePaymentExcelValidation: (state, action) => {
      state.massivePayments.excel.validation.data = action.payload.data
      state.massivePayments.excel.validation.isLoading =
        action.payload.isLoading
      state.massivePayments.excel.validation.errors = action.payload.errors
    },
    setMassivePaymentExcelPayment: (state, action) => {
      state.massivePayments.excel.payment.data = action.payload.data
      state.massivePayments.excel.payment.isLoading = action.payload.isLoading
      state.massivePayments.excel.payment.error = action.payload.error
    },
    setMassivePaymentExcelStatus: (state, action) => {
      state.massivePayments.excel.status.data = action.payload.data
      state.massivePayments.excel.status.isLoading = action.payload.isLoading
      state.massivePayments.excel.status.error = action.payload.error
    },
    setBridgeComission: (state, action) => {
      state.bridge.comission.data = action.payload.data
      state.bridge.comission.isLoading = action.payload.isLoading
      state.bridge.comission.error = action.payload.error
    },
    setBridgeTransaction: (state, action) => {
      state.bridge.transaction.data = action.payload.data
      state.bridge.transaction.isLoading = action.payload.isLoading
      state.bridge.transaction.error = action.payload.error
    },
  },
})

export const {
  setTransactions,
  setNewTransaction,
  setBalances,
  setComission,
  setMassivePaymentExcelValidation,
  setMassivePaymentExcelPayment,
  setMassivePaymentExcelStatus,
  setBridgeComission,
  setBridgeTransaction,
} = transactions.actions
export default transactions.reducer
